import React from 'react';
import styled from 'styled-components';
import RightDoubleArrow from '../assets/hotels/details/right-double-arrow.svg';

const RightDoubleArrowIcon = styled(RightDoubleArrow as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width};
  height: ${props => props.height};
  /* fill: ${props => props.fill || 'black'}; */

  /* margin: ${props => props.margin}; */

  path:nth-of-type(2) {
    fill: ${props => props.fill || '#2276e3'};
  }
  /* cursor: pointer; */
`;

export default RightDoubleArrowIcon;
